import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';
import { HangfireJobInfoDTO } from './hangfire-jobs.models';

/**
 * Read-only HTTP client for the Uniformax Hangfire Jobs admin endpoint.
 */
@Injectable({ providedIn: 'root' })
export class HangfireJobsApiService {
  private readonly baseUrl = environment.apiRoot + 'api/HangfireJobs';

  constructor(private http: HttpClient) {}

  async getList(): Promise<HangfireJobInfoDTO[]> {
    const url = `${this.baseUrl}/List`;
    return firstValueFrom(this.http.get<HangfireJobInfoDTO[]>(url));
  }
}
